module.exports = __webpack_public_path__ + "static/img/1.f4413c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/eng/1.png
// module id = dk1E
// module chunks = 0